import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { getReporteesList, getReporteesThunk } from "../../asyncThunks/overView/reportees";

const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const reporteesData = createSlice({
    name: "overView/reporteesData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getReporteesThunk?.pending, (state, action) => {
            state.error = null;
            state.loading = true;
        });
        builder.addCase(getReporteesThunk?.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(getReporteesThunk?.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },
});

export default reporteesData.reducer;
